import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { removeQueries } from 'Utils/routerUtils'
import SvgIcon from 'Components/SvgIcon'
import { FILTER_ORDER_TYPE } from 'Defaults/filters'
import { RenderFilterSection } from '../index'
import ListingCountFloatingBar from '../ListingCountFloatingBar'
import {
  _FilterView, _LargeScreenCloseBtn, _ShowFrom768,
  _StatusFilter, _FilterTitle,
} from './styles'

export const selectedFilterCountHook = ({
  filterLookup = {},
  lastSearchObj = {},
  startShowOnMobile = false,
  basicFilterKeys = [],
  specialFilterKeys = [],
}) => {
  const [filterCount, updateFilterCount] = useState(0)
  const getFilterCount = (lookup, searchObj) => {
    const _lookup = startShowOnMobile
      ? R.omit(specialFilterKeys, lookup)
      : R.omit([...basicFilterKeys, ...specialFilterKeys], lookup)
    const filters = Object.keys(_lookup)
    const existingFiltersCount = filters.filter((filter) => searchObj[filter]).length
    updateFilterCount(existingFiltersCount)
  }
  useEffect(() => {
    if(filterLookup) {
      getFilterCount(filterLookup, lastSearchObj)
    }
  }, [lastSearchObj])
  useEffect(() => {
    // update filter count on init
    if(filterLookup) {
      getFilterCount(filterLookup, lastSearchObj)
    }
  }, [filterLookup])
  return filterCount
}

const FiltersView = (
  {
    googleAnalyticsEvent,
    toggleMobileFilter,
    filterLookup,
    basicFilterKeys,
    specialFilterKeys,
    offer,
    showMobileVersion = false,
    selectedMiniSideBarMenuState,
    isForSideBar,
    isArchive,
    isLoading = false,
    pagination,
  }) => {
  const containerRef = useRef(null)
  const closeRef = useRef(null)

  useEffect(() => {
    if(closeRef.current) closeRef.current.focus()
  }, [closeRef.current])

  const closeMobileFilter = () => {
    toggleMobileFilter(false)
    selectedMiniSideBarMenuState('')
  }
  const onClickLeftButton = () => {
    const _basicFiltersKeys = showMobileVersion ? [] : basicFilterKeys
    const _lookup = R.omit([..._basicFiltersKeys, ...specialFilterKeys], filterLookup)

    removeQueries(Object.keys(_lookup))
    googleAnalyticsEvent({
      category: 'search',
      action: '[Filter Reset Click]',
    })
  }
  const onClickListingCountButton = () => {
    googleAnalyticsEvent({
      category: 'search',
      action: '[Filter Done Click]',
    })
    closeMobileFilter()
  }

  return (
    <div>
      <_FilterView ref={containerRef} data-test-id={'filterView'}>
        {
          !isForSideBar && (
            <_LargeScreenCloseBtn
              ref={closeRef}
              aria-label="Close filter view"
              onClick={closeMobileFilter}
            >
              <SvgIcon name={'#icon-slim-close'} width={14} height={14} />
            </_LargeScreenCloseBtn>
          )
        }

        <_StatusFilter>
          <_FilterTitle>
            Listing Status
          </_FilterTitle>
          <RenderFilterSection
            isBasic
            offer={offer}
            orderType={FILTER_ORDER_TYPE.SPECIAL}
          />
        </_StatusFilter>

        <_ShowFrom768 forceShow={isForSideBar}>
          <RenderFilterSection
            isForSideBar={isForSideBar}
            offer={offer}
            isBasic={false}
            orderType={FILTER_ORDER_TYPE.BASIC}
            showMobileVersion={showMobileVersion}
          />
        </_ShowFrom768>
        <RenderFilterSection
          isForSideBar={isForSideBar}
          offer={offer}
          isBasic={false}
          orderType={FILTER_ORDER_TYPE.ADVANCED}
          showMobileVersion={showMobileVersion}
        />
        <div style={{ width: '100%', height: '100px' }} />
      </_FilterView>
      <ListingCountFloatingBar
        parentContainerRef={containerRef && containerRef.current}
        leftButtonLabel="Clear"
        onClickLeftButton={onClickLeftButton}
        onClickListingCountButton={onClickListingCountButton}
        isArchive={isArchive}
        isLoading={isLoading}
        pagination={pagination}
        mobileStyle={showMobileVersion}
        offer={offer}
      />
    </div>
  )
}
FiltersView.propTypes = {
  googleAnalyticsEvent: PropTypes.func,
  basicSearch: PropTypes.shape({}),
  advanceSearch: PropTypes.shape({}),
  searchQueryObj: PropTypes.shape({}),
  toggleMobileFilter: PropTypes.func,
  selectedMiniSideBarMenuState: PropTypes.func,
  showMobileVersion: PropTypes.bool,
  offer: PropTypes.string,
  // modeType: PropTypes.string,
  filterLookup: PropTypes.shape({}),
  basicFilterLookup: PropTypes.shape({}),
  basicFilterKeys: PropTypes.arrayOf(PropTypes.string),
  specialFilterKeys: PropTypes.arrayOf(PropTypes.string),
  isForSideBar: PropTypes.bool,
  isArchive: PropTypes.bool,
  isLoading: PropTypes.bool,
  pagination: PropTypes.shape({
    total: PropTypes.number,
    perPage: PropTypes.number,
    currentPage: PropTypes.number,
  }),
}
export default FiltersView
